export const HELP_CENTER = {
  HOME: 'help_center',
  WEBVIEW: {
    HOME: 'help_center-webview',
  },
}
